import * as types from "../constants/actionConstants";

// QDII-2139: tracks template save/create requests in flight so editors can
// block or await parent saves until child template creates have settled.
const initialState = {
    count: 0
};

function saveInFlightReducer(state = initialState, action) {
    switch (action.type) {
        case types.TEMPLATE_SAVE_START:
            return {
                ...state,
                count: state.count + 1
            };

        case types.TEMPLATE_SAVE_END:
            return {
                ...state,
                count: Math.max(0, state.count - 1)
            };

        default:
            return state;
    }
}

export default saveInFlightReducer;
